import { defineMessages } from "react-intl";

export const messages = defineMessages({
  dialogTitle: {
    id: "dialog.allowMediaGuide.edge.desktop.title",
    defaultMessage: "Edge (Allow Camera and Microphone)",
    description: "Title for dialog Edge",
  },
  imgAltText: {
    id: "dialog.allowMediaGuide.edge.desktop.image.alt.text",
    defaultMessage: "Edge (Allow Camera and Microphone Guide)",
    description: "Image text",
  },
  step1: {
    id: "dialog.allowMediaGuide.edge.desktop.step.1.text",
    defaultMessage:
      "Click the icon (marker 1, see image below) to display the dialog.",
    description: "Step 1",
  },
  step2: {
    id: "dialog.allowMediaGuide.edge.desktop.step.2.text",
    defaultMessage:
      "Click the camera and microphone (marker 2, see image below) and select Allowed to allow access to the camera and microphone (marker 2, see image below).",
    description: "Step 2",
  },
  step3: {
    id: "dialog.allowMediaGuide.edge.desktop.step.3.text",
    defaultMessage: "Click Refresh the page.",
    description: "Step 3",
  },
});
